var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3241 3.05901C11.8551 2.59002 11.0607 2.743 10.7995 3.35262L9.47994 6.43155C8.39583 6.11034 7.17394 6.37737 6.31773 7.23359L5.30032 8.25099C5.08065 8.47066 5.08065 8.82682 5.30032 9.04649L6.90665 10.6528L2.60225 14.9572C2.38258 15.1769 2.38258 15.533 2.60225 15.7527C2.82192 15.9724 3.17808 15.9724 3.39775 15.7527L7.70214 11.4483L9.30851 13.0547C9.52818 13.2743 9.88434 13.2743 10.104 13.0547L11.1214 12.0373C11.9776 11.1811 12.2447 9.95916 11.9234 8.87505L15.0024 7.55551C15.612 7.29424 15.765 6.49988 15.296 6.0309L12.3241 3.05901Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.194226a0dcbcfeeed6f31c3bb8ed44c3.svg";
export { ForwardRef as ReactComponent };